import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealMarketUnemploymentRateField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          suffix='%'
          onValueChange={handleChange}
          customInput={TextField}
          label='Unemployment Rate'
          id='market_unemployment_rate'
          aria-describedby='market-unemployment-rate-helper-text'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
        />
        {error ? (
          <FormHelperText id='market-unemployment-rate-helper-text'>
            {error}
          </FormHelperText>
        ) : (
          <FormHelperText id='market-unemployment-rate-helper-text'>
            Enter the market average unemployment rate
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
